import { z } from 'zod'
import { CourtesyStatus } from '~library/enums'
import {
  managerBenefitFileSchema,
  managerBenefitCommonSchema
} from '~library/models'
import { fileDescriptionSchema } from './file-description'

export const benefitAndVoucherManagementSchema = z
  .object({
    /** 指派禮遇Id */
    id: z.string(),
    /** 禮遇商品 */
    commodityId: z.string(),
    /** 狀態 */
    status: z.nativeEnum(CourtesyStatus),
    /** 券號 */
    couponNo: z.string(),
    /** 使用起始時間 */
    useStartTime: z.string(),
    /** 使用截止時間 */
    useEndTime: z.string(),
    /** 檔案 */
    file: z.array(managerBenefitFileSchema)
  })
  .merge(fileDescriptionSchema)
  .merge(managerBenefitCommonSchema)

export interface BenefitAndVoucherManagement
  extends z.infer<typeof benefitAndVoucherManagementSchema> {}
